module.exports = __webpack_public_path__ + "static/barbie-6049dc2beefc131859a1db3370a35e70.png";